'use client';

import Link from 'next/link';
import type { CalendarEvent } from './types';
import { calendarEventHref, formatEventWhen, isExternalCalendarLink } from './eventUtils';

type Props = {
  event: CalendarEvent;
  calendarPath: string;
};

export function CalendarSidebarEventLink({ event, calendarPath }: Props) {
  const href = calendarEventHref(event, calendarPath);
  const body = (
    <>
      <strong>{event.title}</strong>
      <span>{formatEventWhen(event)}</span>
    </>
  );

  if (isExternalCalendarLink(href)) {
    return (
      <a
        href={href}
        className="calendar-sidebar__event calendar-sidebar__event-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {body}
      </a>
    );
  }

  return (
    <Link href={href} className="calendar-sidebar__event calendar-sidebar__event-link">
      {body}
    </Link>
  );
}
